var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"max-width":"502px"}},[_c('h1',{class:_vm.responsiveClasses({
        tablet: 'display-3 mb-4',
        desktop: `${_vm.desktopHeaderDisplaySize} mb-5`,
      })},[_vm._v(" "+_vm._s(_vm.researcherHeaderText)+" ")]),_c('p',{staticClass:"mb-11"},[_vm._v(" "+_vm._s(_vm.researcherHeaderSubtext)+" ")]),_c('researcher-signup-email'),_c('privacy-policy-disclaimer',{staticClass:"mb-9"}),_c('researcher-o-auth',{staticClass:"mb-5",attrs:{"provider":"google"}}),_c('researcher-o-auth',{staticClass:"mb-10",attrs:{"provider":"outlook"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }